import Yup from 'utils/validation';
import { validDDDs } from 'utils/basicUtils';

export interface TransportSeturFormProps {
  selectedId?: string;
  item?: any;
}

export const states = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

export const transportSeturInitialValues = {
  id: '',
  businessOwner: [''],
  businessRepresentative: '',
  businessType: '',
  description: '',
  phone: '',
  document: '',
  facebookLink: '',
  experiences: [],
  googleMapsLink: '',
  instagramLink: '',
  status: '',
  tradeEmail: '',
  tradeName: '',
  youtubeLink: '',
  title: '',
  site: '',
  whatsapp: '',
  image: [],
  userId: 0,
  address_id: 0,
  createdAt: '',
  updatedAt: '',
  deletedAt: '',
  address: {
    id: 0,
    additionalData: '',
    city: '',
    neighborhood: '',
    number: '',
    state: '',
    street: '',
    zipCode: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
  },
  images: [],
  structures: [],
  user: '',
};

export const transportSeturValidationSchema = Yup.object().shape({
  id: Yup.number(),
  businessOwner: Yup.array().of(
    Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0)
  ),
  businessRepresentative: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  businessType: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  description: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  document: Yup.string().notRequired(),
  googleMapsLink: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  tradeEmail: Yup.string().notRequired(),
  tradeName: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  title: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  phone: Yup.string().notRequired(),
  site: Yup.string().notRequired(),
  youtubeLink: Yup.string().notRequired(),
  instagramLink: Yup.string().notRequired(),
  facebookLink: Yup.string().notRequired(),
  whatsapp: Yup.string(),
  image: Yup.array().min(1).required(),
  address: Yup.object().shape({
    id: Yup.number(),
    additionalData: Yup.string(),
    city: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    neighborhood: Yup.string()
      .matches(/^(?!^\d+$)[\d\D]*$/, 'O bairro não pode conter somente números')
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    number: Yup.string().matches(/^\d*$/, 'O campo número deve conter apenas números').required(),
    state: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    street: Yup.string()
      .matches(/^(?!\d+$).*/, 'O campo endereço não pode ser apenas números')
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    zipCode: Yup.string().notRequired(),
  }),
  images: Yup.array().min(1).required(),
});
